const BLOCKED_NAVIGATION_SCHEMES = {
  javascript: true,
  vbscript: true,
  livescript: true,
  data: true,
  file: true,
  blob: true,
}

const MAX_NAVIGATION_TARGET_LENGTH = 500

export function isNavigationTargetAllowed(target) {
  const trimmed = target?.trim()
  if (!trimmed) return false
  if (trimmed.length > MAX_NAVIGATION_TARGET_LENGTH) return false
  if (hasAsciiControlCharacter(trimmed)) return false

  let parsed
  try {
    parsed = new URL(trimmed)
  } catch {
    return false
  }

  const scheme = parsed.protocol.slice(0, -1).toLowerCase()
  return Boolean(scheme && !BLOCKED_NAVIGATION_SCHEMES[scheme])
}

function hasAsciiControlCharacter(value) {
  for (let index = 0; index < value.length; index += 1) {
    const code = value.charCodeAt(index)
    if (code <= 31 || code === 127) return true
  }
  return false
}
